import React, { Component } from "react";
import ReactDOM from "react-dom";
import SelectField from 'material-ui/SelectField';
import MItem from 'material-ui/MenuItem';
import Chip from 'material-ui/Chip';

import { FullRow, Row, Col } from "../framework/Grid";
import AcquireWebComponent from "../framework/MaterialUI";
import SelectedAttrs from "../Segment/SelectedAttrs";
import { Menu, MenuItem, Typeahead } from "react-bootstrap-typeahead";

import map from "lodash/map";
import find from "lodash/find";
import groupBy from "lodash/groupBy";
import remove from "lodash/remove";
import filter from "lodash/filter";
import some from "lodash/some";
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import {
  Dialog,
  Checkbox,
  IconButton,
  Popover as MaterialPopover,
  RaisedButton,
} from "material-ui";
import {
  splitNumber,
  getUrlParameterByName,
  debounceEventHandler,
  pushParamsToUrl,
} from "../../utils/utility";
import {
  parseSegment,
  parsePlottedValues,
  parseZipcode,
  attr2Rules,
} from "../../utils/segment_util";
import TreePanel from "./TreePanel";
import PoltMapPanel from "./PlotMapPanel";
import moment from "moment";

import "./index.css";
import ValuePanel from "./ValuePanel";
import SubValuePanel from "./SubValuePanel";
import GeoStatesPanel from "./GeoStatesPanel";
import ZipcodePanel from "./ZipcodePanel";
import AutoMakePanel from "./AutoMakePanel";
import RegionLocalePanel from "./RegionLocalePanel";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import flattenDeep from "lodash/flattenDeep";
import isEqual from "lodash/isEqual";

const geoCategory = {
  name: "Geography",
  attributes: [
    { id: 1, name: "Add City / State" },
    { id: 7, name: "Add Zip Code" },
    { id: 2, name: "Add County" },
    { id: 4, name: "Add DMA" },
    { id: 6, name: "Plot a Custom Radius" },
  ],
};
const geoInfoText = (
  <section>
    <div className="mb-10">
      <strong>Selecting Geographic Attributes:</strong>
    </div>
    <div>
      You can build your audience by selecting only 1 geographic option.
    </div>
    <div>
      If you select a different geography type, any selections made will be
      deleted.
    </div>
  </section>
);
const MenuDivider = (props) => <li className="divider" role="separator" />;
const MenuHeader = (props) => <li {...props} className="dropdown-header" />;
class AudienceBuilder extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCatId: null,
      selectedAttrId: null,
      errorVisible: false,
      openCancel: false,
      openReset: false,
      openViewSelected: false,
      cancelAnchorEl: null,
      openExportCsvModal: false,
      geoDropDownList: [],
      otherSegmentDropDownList: [],
      exportCsvField: {
        email: true,
        socialDisplay: true,
        directMail: true,
        geo: {
          id: null,
          name: null,
        },
        other: {
          id: null,
          name: null,
        },
        channel: []
      }
    };

    const cid = getUrlParameterByName("cid");
    if (cid) {
      this.props.selectClient(parseInt(cid, 10));
      if (!props.demoAttributes) {
        props.loadAttributes(cid);
      }
    }
  }
  onUnload = (e) => {
    // the method that will be used for both add and remove event
    e.preventDefault();
    e.returnValue = "";
  };
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
  }
  componentDidMount() {
    window.addEventListener("beforeunload", this.onUnload);

    if (getUrlParameterByName("cid")) {
      this.props.selectClient(parseInt(getUrlParameterByName("cid"), 10));
      if (getUrlParameterByName("id")) {
        this.props.getSegmentDetail(
          getUrlParameterByName("id"),
          getUrlParameterByName("cid"),
        );
      }
    } else {
      let url = window.location.pathname;
      if (getUrlParameterByName("id")) {
        url = pushParamsToUrl(url, "id", getUrlParameterByName("id"));
      }
      this.props.history.push(
        pushParamsToUrl(url, "cid", this.props.selected_client),
      );
    }
    if (!this.props.allstates || isEmpty(this.props.allstates))
      this.props.getAllStates();
    //get all states
    //if (!this.props.all_state_cities || isEmpty(this.props.all_state_cities))
    //this.props.getAllStateCities(); // get all states and cities
    this.props.loadCounties();
    this.props.loadDMAs();
    let attrId;
    if (
      !isEmpty(this.props.plotted_values) ||
      !isEmpty(this.props.selected_city) ||
      !isEmpty(this.props.selected_state) ||
      !isEmpty(this.props.selected_county) ||
      !isEmpty(this.props.selected_dma) ||
      !isEmpty(this.props.zipcode)
    ) {
      if (!isEmpty(this.props.selected_dma)) {
        attrId = 4;
      } else if (!isEmpty(this.props.selected_county)) {
        attrId = 2;
      } else if (
        !isEmpty(this.props.selected_state) ||
        !isEmpty(this.props.selected_city)
      ) {
        attrId = 1;
      }
      this.setState(
        {
          selectedCatId: 0,
          selectedAttrId: attrId,
          selected_segments: this.props.selected_segments,
        },
        () => {
          this.updateSelectedFocus();
        },
      );
    } else {
      this.setState(
        {
          selected_segments: this.props.selected_segments,
        },
        () => {
          this.updateSelectedFocus();
        },
      );
    }
    this.recalculateTotal();
  }

  updateSelectedFocus() {
    if (
      !this.state.selected_segments ||
      !this.props.demoAttributes ||
      !this.props.demoAttributes[0]
    )
      return;
    map(this.state.selected_segments, (seg) => {
      if (seg && seg.toString().indexOf("606") >= 0) {
        const model = find(
          this.props.demoAttributes[0].attributes[2].values,
          (m) => {
            return m.id === seg;
          },
        );
        this.handleAutoModelSelected(model, true);
      }
      if (seg && seg.toString().indexOf("605") >= 0) {
        const make = find(
          this.props.demoAttributes[0].attributes[1].values,
          (m) => {
            return m.id === seg;
          },
        );
        this.handleAutoMakeSelected(make, true);
      }
      if (seg && seg.toString().indexOf("1503") >= 0) {
        const locale = find(
          this.props.demoAttributes[2].attributes[2].values,
          (m) => {
            return m.id === seg;
          },
        );
        this.handleCultureLocaleSelected(locale, true);
      }
      if (seg && seg.toString().indexOf("1502") >= 0) {
        const region = find(
          this.props.demoAttributes[2].attributes[1].values,
          (m) => {
            return m.id === seg;
          },
        );
        this.handleCultureRegionSelected(region, true);
      }
    });
    let catId;
    let attrId;
    map(this.props.demoAttributes, (c) => {
      map(c.attributes, (attr) => {
        if (attr.subAttributes) {
        } else {
          if (
            some(attr.values, (val) => {
              return this.state.selected_segments.indexOf(val.id) >= 0;
            })
          ) {
            catId = c.id;
            attrId = attr.id;
          }
        }
      });
    });
    this.setState({
      selectedCatId: catId,
      selectedAttrId: attrId,
      selected_segments: undefined,
    });
    this.delayRecalculate();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected_client !== this.props.selected_client) {
      if (
        this.props.selected_client > 1 &&
        getUrlParameterByName("cid") !== this.props.selected_client
      ) {
        /*if (getUrlParameterByName("id")) {
          this.props.history.push(
            pushParamsToUrl(
              "/segments/list/active",
              "cid",
              this.props.selected_client,
            ),
          );
        } else {*/
        let url = window.location.pathname;

        this.props.history.push(
          pushParamsToUrl(url, "cid", this.props.selected_client),
        );
        //}
      }
    }
    if (this.props.isNameDuplicated === true) {
      if (!this.state.errorVisible) this.setState({ errorVisible: true });
    } else {
      if (this.state.errorVisible === true)
        this.setState({ errorVisible: false });
    }
    if (
      this.props.save_segment_success === false &&
      prevProps.save_segment_success !== this.props.save_segment_success
    ) {
      this.setState({
        errorVisible: true,
      });
      if (String(this.props.save_segment_error_errorNo) === "422004")
        this.setState({
          showSaveErrorDialog: true,
          subject: "",
          comments: "",
          openContactForm: false,
        });
    }
    if (!isEqual(prevProps.demoAttributes, this.props.demoAttributes)) {
      this.updateSelectedFocus();
    }
    if (
      this.props.active_segment_attributes &&
      !isEqual(
        this.props.active_segment_attributes,
        prevProps.active_segment_attributes,
      )
    ) {
      if (this.props.active_segment_attributes.rawData) {
        let rawData = JSON.parse(this.props.active_segment_attributes.rawData);
        this.props.segment_active_creation.selected_segments =
          rawData.selected_segments;
        this.props.segment_active_creation.plotted_values =
          rawData.plotted_values;
        this.props.segment_active_creation.selected_city =
          rawData.selected_city;
        this.props.segment_active_creation.selected_state =
          rawData.selected_state;
        this.props.segment_active_creation.selected_county =
          rawData.selected_county;
        this.props.segment_active_creation.selected_dma = rawData.selected_dma;
        this.props.segment_active_creation.zipcode = rawData.zipcode;
        this.props.segment_active_creation.segment_name = rawData.name;
        const segmentNameInput = ReactDOM.findDOMNode(
          this.refs.segmentNameInput,
        );
        if (segmentNameInput) segmentNameInput.value = rawData.name;
        this.props.active_segment_attributes.rules.forEach((item) => {
          this.props.segment_active_creation.rules_id.push({
            id: item.id,
            attributeId: item.attributeId,
          });
        });
        this.props.segment_active_creation.segment_id = this.props.active_segment_attributes.id;
        let attrId;
        if (
          !isEmpty(rawData.plotted_values) ||
          !isEmpty(rawData.selected_city) ||
          !isEmpty(rawData.selected_state) ||
          !isEmpty(rawData.selected_county) ||
          !isEmpty(rawData.selected_dma) ||
          !isEmpty(rawData.zipcode)
        ) {
          if (!isEmpty(rawData.selected_dma)) {
            attrId = 4;
          } else if (!isEmpty(rawData.selected_county)) {
            attrId = 2;
          } else if (
            !isEmpty(rawData.selected_state) ||
            !isEmpty(rawData.selected_city)
          ) {
            attrId = 1;
          }
          this.setState(
            {
              selectedCatId: 0,
              selectedAttrId: attrId,
              selected_segments: rawData.selected_segments,
            },
            () => {
              this.updateSelectedFocus();
            },
          );
        } else {
          this.setState(
            {
              selected_segments: rawData.selected_segments,
            },
            () => {
              this.updateSelectedFocus();
            },
          );
        }
        setTimeout(() => {
          this.recalculateTotal();
        }, 1000);
      }
    }
  }

  recalculateTotal(targetOnly) {
    if (this.props.zipcode.length > 0) {
      const newSegment = parseZipcode(this.props, this.props.segment_name);
      this.props.getZipcodeAudienceCount(
        {
          rules: newSegment.rules,
          filtered: {
            targetHouseholdsOnly: !isUndefined(targetOnly)
              ? Boolean(targetOnly)
              : Boolean(this.props.targetHouseholdsOnly),
          },
        },
        this.props.segment_id,
      );
    }
    const newSegment = parseSegment(
      this.props,
      this.props.segment_name,
      this.state.plotted_values,
    );
    if (
      newSegment.rules.length > 0 ||
      this.props.selected_city.length > 0 ||
      this.props.selected_state.length > 0 ||
      this.props.zipcode.length > 0 ||
      this.props.selected_dma.length > 0 ||
      this.props.selected_county.length > 0 ||
      !isEmpty(this.props.plotted_values)
    ) {
      const { targetHouseholdsOnly } = this.props;

      this.props.getAudienceCount(
        {
          rules: newSegment.rules,
          filtered: {
            targetHouseholdsOnly: isUndefined(targetOnly)
              ? Boolean(targetHouseholdsOnly)
              : targetOnly,
          },
        },
        this.props.segment_id,
      );
    } else {
      this.props.clearAudienceCount();
    }
  }

  getAttributesPanel() {
    if (this.state.selectedCatId >= 0) {
      const cat =
        this.state.selectedCatId == 0
          ? geoCategory
          : find(this.props.demoAttributes, (attrs) => {
              return this.state.selectedCatId == attrs.id;
            });
      if (cat && cat.attributes) {
        let selectId = this.state.selectedAttrId;
        if (cat.id === 7) {
          const attrs = Object.assign([], cat.attributes);
          remove(attrs, (item) => {
            return item.id === 606;
          });
          find(attrs, (item) => {
            return item.id === 605;
          }).name = "Auto Make/Model";
          return (
            <div>
              <TreePanel
                key={cat.name + "_tree_panel"}
                displayData={attrs}
                selectedId={selectId}
                title={cat.name}
                onClick={(id) => {
                  this.setState({ selectedAttrId: id });
                }}
              />
            </div>
          );
        }
        if (cat.id === 15) {
          const attrs = Object.assign([], cat.attributes);
          remove(attrs, (item) => {
            return item.id === 1503;
          });
          find(attrs, (item) => {
            return item.id === 1502;
          }).name = "Region/Locale";
          return (
            <div>
              <TreePanel
                key={cat.name + "_tree_panel"}
                displayData={attrs}
                selectedId={selectId}
                title={cat.name}
                onClick={(id) => {
                  this.setState({ selectedAttrId: id });
                }}
              />
            </div>
          );
        }
        if (
          !isEmpty(this.props.selected_city) ||
          !isEmpty(this.props.selected_state)
        ) {
          selectId = 1;
        }
        if (!isEmpty(this.props.selected_dma)) {
          selectId = 4;
        }
        if (!isEmpty(this.props.selected_county)) {
          selectId = 2;
        }
        if (!isEmpty(this.props.plotted_values)) {
          selectId = 6;
        }
        if (!isEmpty(this.props.zipcode)) {
          selectId = 7;
        }
        return (
          <div>
            <TreePanel
              key={cat.name + "_" + selectId + "_tree_panel"}
              displayData={cat.attributes}
              tooltip={cat.name === "Geography" ? geoInfoText : undefined}
              selectedId={selectId}
              title={cat.name}
              onClick={(id) => {
                if (cat.name === "Geography") {
                  if (id !== selectId && id !== this.state.selectedAttrId) {
                    this.props.clearAllCounty();
                    this.props.clearAllDMA();
                    this.props.clearAllSelectedCity();
                    this.props.clearAllSelectedState();
                    this.props.clearAllZipCode();
                    this.props.setPlotValues({});

                    setTimeout(() => {
                      this.recalculateTotal();
                    }, 500);
                  }
                }
                this.setState({ selectedAttrId: id });
              }}
            />
          </div>
        );
      }
    }
  }

  closeMapSelectDialog = () => {
    this.setState({ openMapDialog: false, plotted_values: null });
    this.props.clearAudienceCount();
  };

  updateAudienceCountWithPlotted(plottedRadius) {
    this.setState({
      plotted_values: plottedRadius,
    });
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      100,
    );
  }

  handleApplyPlotted(val) {
    this.props.clearAllSelectedState();
    this.props.clearAllSelectedCity();
    this.props.clearAllDMA();
    this.props.clearAllCounty();
    this.props.clearAllZipCode();
    this.props.setPlotValues(val);
    this.setState({
      plotted_values: null,
    });
    const plottedRules = [];
    const rule = parsePlottedValues(val);
    if (rule) {
      plottedRules.push(rule);
      setTimeout(
        function () {
          this.props.getPlottedAudienceCount(
            {
              rules: plottedRules,
              filtered: {
                targetHouseholdsOnly: Boolean(this.props.targetHouseholdsOnly),
              },
            },
            this.props.segment_id,
          );
        }.bind(this),
        100,
      );
    }

    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      100,
    );
  }

  _handleCancelPlotted() {
    this.setState({
      plotted_values: null,
    });
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      50,
    );
  }

  handleSelectAllStates(val, flag) {
    this.props.selectAllState(val, flag);
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      100,
    );
  }

  handleSelectAllDMAStates(stateIds, flag) {
    //this.props.selectCounty(countyObj, label, isChecked);
    map(this.props.dmas, (d) => {
      this.props.selectDMA(d, d.label.split(",")[1], flag);
    });
    this.props.selectAllState(stateIds, flag);

    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      100,
    );
  }

  handleSelectAllCountyStates(stateIds, flag) {
    map(this.props.counties, (c) => {
      this.props.selectCounty(c, c.label.split(",")[1], flag);
    });
    this.props.selectAllState(stateIds, flag);
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      100,
    );
  }

  chooseSegmentValues(id, flag) {
    let selected = this.props.selected_segments
      ? this.props.selected_segments
      : [];
    const idx = selected ? selected.indexOf(id) : -1;
    if (idx >= 0 && !flag) {
      selected.splice(idx, 1);
    } else {
      if (flag && idx < 0) selected.push(id);
    }
    this.props.selectSegment(selected);

    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      20,
    );
  }

  getValuesPanel() {
    if (this.state.selectedAttrId) {
      const cat =
        this.state.selectedCatId == 0
          ? geoCategory
          : find(this.props.demoAttributes, (attrs) => {
              return this.state.selectedCatId == attrs.id;
            });
      const attr = find(cat.attributes, (a) => {
        return this.state.selectedAttrId == a.id;
      });
      if (cat && attr) {
        switch (this.state.selectedCatId) {
          case 0:
            switch (this.state.selectedAttrId) {
              case 2:
                return (
                  <div style={{ flexGrow: "1" }}>
                    <GeoStatesPanel
                      key={cat.name + "+county_tree_panel"}
                      displayData={this.props.allstates}
                      cities={this.props.counties}
                      subTitle={"COUNTY"}
                      title={"State"}
                      onClick={(id) => {
                        this.setState({ selectedAttrId: id });
                      }}
                      showSelectAll={false}
                      selectCity={this.handleCountySelected.bind(this)}
                      selectState={this.handleCountyStateSelected.bind(this)}
                      selected_cities={this.props.selected_county}
                      selected_states={this.props.selected_state}
                      selectAllStates={this.handleSelectAllCountyStates.bind(
                        this,
                      )}
                    />
                  </div>
                );
              case 6:
                return (
                  <div style={{ flexGrow: "1", position: "relative" }}>
                    <PoltMapPanel
                      key={this.state.mapKey}
                      onClose={this.closeMapSelectDialog}
                      getAudienceCount={this.props.getAudienceCount}
                      clearAudienceCount={this.props.clearAudienceCount}
                      onUpdateAudienceCount={this.updateAudienceCountWithPlotted.bind(
                        this,
                      )}
                      onApplyChanges={this.handleApplyPlotted.bind(this)}
                      onCancelChanges={this._handleCancelPlotted.bind(this)}
                      plottedValue={this.props.plotted_values}
                    />
                  </div>
                );
              case 7:
                return (
                  <div style={{ flexGrow: "1" }}>
                    <ZipcodePanel
                      addZipCode={this.handleZipcodeAdded.bind(this)}
                      zipcode={this.props.zipcode}
                    />
                  </div>
                );
              case 4:
                return (
                  <div style={{ flexGrow: "1" }}>
                    <GeoStatesPanel
                      key={cat.name + "_dma_tree_panel"}
                      displayData={this.props.allstates}
                      cities={this.props.dmas}
                      subTitle={"DMA"}
                      title={"State"}
                      onClick={(id) => {
                        this.setState({ selectedAttrId: id });
                      }}
                      showSelectAll={false}
                      selectCity={this.handleDMASelected.bind(this)}
                      selectState={this.handleDMAStateSelected.bind(this)}
                      selected_cities={this.props.selected_dma}
                      selected_states={this.props.selected_state}
                      selectAllStates={this.handleSelectAllDMAStates.bind(this)}
                    />
                  </div>
                );
              case 1:
              default:
                return (
                  <div style={{ flexGrow: "1" }}>
                    <GeoStatesPanel
                      key={cat.name + "_state_city_tree_panel"}
                      displayData={this.props.allstates}
                      cities={this.props.allcities}
                      getCities={this.props.getCities}
                      ifLoading={this.props.ifLoading}
                      stateValues={this.props.all_state_cities}
                      title={"State"}
                      subTitle={"City"}
                      onClick={(id) => {
                        this.setState({ selectedAttrId: id });
                      }}
                      selectCity={this.handleCitySelected.bind(this)}
                      selectState={this.handleStateSelected.bind(this)}
                      selected_cities={this.props.selected_city}
                      selected_states={this.props.selected_state}
                      selectAllStates={this.handleSelectAllStates.bind(this)}
                    />
                  </div>
                );
                break;
            }
            break;
          case 7:
            switch (this.state.selectedAttrId) {
              case 605:
              case 606:
                const models = find(cat.attributes, (a) => {
                  return a.id === 606;
                });
                return (
                  <div style={{ flexGrow: "1" }}>
                    <AutoMakePanel
                      makes={attr.values}
                      models={models.values}
                      granularity={attr.granularity}
                      granularity={attr.granularity}
                      selected_make={this.props.selected_make}
                      selected_model={this.props.selected_model}
                      selectMake={this.handleAutoMakeSelected.bind(this)}
                      selectModel={this.handleAutoModelSelected.bind(this)}
                      selectAllAutoMakes={this.handleAllAutoMakeSelected.bind(
                        this,
                      )}
                    />
                  </div>
                );
            }
          case 15:
            switch (this.state.selectedAttrId) {
              case 1502:
              case 1503:
                const locales = find(cat.attributes, (a) => {
                  return a.id === 1503;
                });
                return (
                  <div style={{ flexGrow: "1" }}>
                    <RegionLocalePanel
                      granularity={attr.granularity}
                      regions={attr.values}
                      locales={locales.values}
                      selected_region={this.props.selected_culture_region}
                      selected_locale={this.props.selected_culture_locale}
                      selectRegion={this.handleCultureRegionSelected.bind(this)}
                      selectLocale={this.handleCultureLocaleSelected.bind(this)}
                    />
                  </div>
                );
            }
          default:
            return attr.values ? (
              <div style={{ flexGrow: "1" }}>
                <ValuePanel
                  granularity={attr.granularity}
                  key={attr.id + "_values_panel"}
                  displayData={attr.values}
                  selected_segments={this.props.selected_segments}
                  title={attr.name}
                  onCheck={(id, isChecked) => {
                    this.chooseSegmentValues(id, isChecked);
                  }}
                />
              </div>
            ) : (
              <div style={{ flexGrow: "1" }}>
                <SubValuePanel
                  key={attr.id + "_subvalues_panel"}
                  displayData={attr.subAttributes}
                  selected_segments={this.props.selected_segments}
                  title={attr.name}
                  onCheck={(id, isChecked) => {
                    this.chooseSegmentValues(id, isChecked);
                  }}
                />
              </div>
            );
        }
      }
    }
  }

  getAttrValuesPanel() {
    //if ()
  }

  handleZipcodeAdded(zipcode) {
    this.props.addZipCode(zipcode);
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      200,
    );
  }

  handleCitySelected(cityObj, label, isInputChecked) {
    this.props.selectCity(cityObj, label, isInputChecked);
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      200,
    );
  }

  handleStateSelected(id, isInputChecked) {
    this.props.selectState(id, isInputChecked);
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      200,
    );
  }

  handleDMAStateSelected(state, isInputChecked) {
    this.props.selectState(state, false);

    map(this.props.dmas, (dma) => {
      if (dma.label.indexOf(state.value) >= 0) {
        this.props.selectDMA(dma, state.value, isInputChecked);
      }
    });
    this.delayRecalculate();
  }

  handleCountyStateSelected(state, isInputChecked) {
    this.props.selectState(state, false);

    map(this.props.counties, (county) => {
      if (county.label.endsWith(`, ${state.value}`)) {
        this.props.selectCounty(county, state.value, isInputChecked);
      }
    });
    this.delayRecalculate();
  }

  handleCountySelected(countyObj, label, isChecked) {
    this.props.selectCounty(countyObj, label, isChecked);
    this.delayRecalculate();
  }

  handleDMASelected(dmaObj, label, isChecked) {
    this.props.selectDMA(dmaObj, label, isChecked);
    this.delayRecalculate();
  }

  handleAllAutoMakeSelected(isChecked) {
    const models = this.props.demoAttributes[0].attributes[2].values;
    const selectedSegments = this.props.selected_segments
      ? this.props.selected_segments
      : [];
    map(models, (m) => {
      const idx = selectedSegments ? selectedSegments.indexOf(m.id) : -1;
      if (idx >= 0) {
        selectedSegments.splice(idx, 1);
      } else {
        selectedSegments.push(m.id);
      }
      this.props.selectModel(m, false);
    });
    const makes = this.props.demoAttributes[0].attributes[1].values;
    map(makes, (m) => {
      const idx = selectedSegments ? selectedSegments.indexOf(m.id) : -1;
      if (idx >= 0) {
        selectedSegments.splice(idx, 1);
      } else {
        selectedSegments.push(m.id);
      }
      this.props.selectMake(m, isChecked);
    });
    this.props.selectSegment(selectedSegments);

    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      20,
    );
  }

  handleAutoMakeSelected(makeObj, isChecked) {
    this.chooseSegmentValues(makeObj.id, isChecked);
    this.props.selectMake(makeObj, isChecked);
  }

  handleAutoModelSelected(modelObj, isChecked) {
    this.chooseSegmentValues(modelObj.id, isChecked);
    this.props.selectModel(modelObj, isChecked);
  }

  handleCultureRegionSelected(obj, isChecked) {
    const attrs = this.props.demoAttributes.find(attr => attr.id === this.state.selectedCatId);
    if (attrs) {
      const target_attrs = attrs.attributes.find(l => l.id === this.state.selectedAttrId);
      const locales = filter(
          target_attrs.values,
          (v) => {
            return v.label.split(" - ")[0] === obj.value;
          },
      );
      map(locales, (l) => {
        let selected = this.props.selected_segments
            ? this.props.selected_segments
            : [];

        const idx = selected ? selected.indexOf(l.id) : -1;
        if (idx >= 0) {
          selected.splice(idx, 1);
        } else {
          selected.push(l.id);
        }
        this.props.selectSegment(selected);
        this.props.selectCultureLocale(l, false);
      });
    }

    this.props.selectCultureRegion(obj, isChecked);
    this.chooseSegmentValues(obj.id, isChecked);
    this.delayRecalculate();
  }

  handleCultureLocaleSelected(obj, isChecked) {
    this.chooseSegmentValues(obj.id, isChecked);
    this.props.selectCultureLocale(obj, isChecked);
    this.delayRecalculate();
  }

  handleSegmentNameChange(e) {
    this.props.setSegmentName(e.target.value);
  }

  verifyAudience() {
    this.props.verifySegmentName(
      this.props.selected_client,
      this.props.segment_name,
    );
  }

  saveSegment() {
    /*
    if (this.state.disabledSaveBtn === true) return;
    else this.setState({ disabledSaveBtn: true });*/

    let segmentName = this.props.segment_name;
    const client_name = this.props.selected_client_name.split(" ").join("_");

    if (this.props.segment_name.indexOf(client_name) < 0)
      segmentName = (
        client_name +
        "_" +
        this.props.segment_name +
        "_" +
        moment().format("YYYYMMDD")
      )
        .split(" ")
        .join("_");
    const newSegment = parseSegment(this.props, segmentName);
    this.props.setSegmentName(segmentName);
    this.props.saveSegment(newSegment);
  }
  removeSelectedVal(id) {
    const {
      selected_segments,
      selected_culture_region,
      selected_culture_locale,
      selected_make,
      selected_model,
    } = this.props;

    const idx = selected_segments.indexOf(id);
    if (idx >= 0) {
      selected_segments.splice(idx, 1);
      this.props.selectSegment(selected_segments);
    }
    const locale = find(selected_culture_locale, (l) => {
      return l.id === id;
    });
    const region = find(selected_culture_region, (r) => {
      return r.id === id;
    });
    const make = find(selected_make, (m) => {
      return m.id === id;
    });
    const model = find(selected_model, (m) => {
      return m.id === id;
    });

    if (locale) {
      this.props.selectCultureLocale(locale, false);
    }
    if (region) {
      this.props.selectCultureRegion(region, false);
    }
    if (make) {
      this.props.selectMake(make, false);
    }
    if (model) {
      this.props.selectModel(model, false);
    }
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      200,
    );
  }
  removePlottedVal() {
    this.props.setPlotValues({});
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      200,
    );
  }

  getSelectedAttrCount() {
    const {
      selected_segments,
      plotted_values,
      selected_state,
      selected_city,
      zipcode,
      selected_county,
      selected_dma,
    } = this.props;
    let sltAttrCount = 0;
    if (selected_segments) sltAttrCount += selected_segments.length;
    if (!isEmpty(plotted_values)) sltAttrCount += 1;
    sltAttrCount += selected_state.length;
    sltAttrCount += selected_city.length;
    sltAttrCount += zipcode.length;
    if (selected_county) sltAttrCount += selected_county.length;
    if (selected_dma) sltAttrCount += selected_dma.length;

    return sltAttrCount;
  }

  handleOpenCancelDialog(e, status) {
    e.preventDefault();
    this.setState({
      openCancel: status,
      cancelAnchorEl: e.currentTarget,
    });
  }

  handleOpenResetDialog(e, status) {
    e.preventDefault();
    this.setState({
      openReset: status,
      resetAnchorEl: e.currentTarget,
    });
  }

  getResetAllPopup() {
    return (
      <MaterialPopover
        open={this.state.openReset}
        anchorEl={this.state.resetAnchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        targetOrigin={{ horizontal: "left", vertical: "center" }}
        onRequestClose={this.handleRequestClose}
      >
        <div
          style={{
            padding: "20px 30px",
            fontSize: "16px",
          }}
        >
          Are you sure you want to reset attributes?
          <br />
          Any selections you have made will not be saved
          <br />
          <br />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <a
                className="btn btn-link btn-sm cancel-btn mr-20 text-bold"
                onClick={(e) => {
                  this.handleOpenResetDialog(e, false);
                }}
              >
                Close
              </a>
            </div>
            <div>
              <a
                className="btn btn-default btn-round btn-sm btn-aa-primary ml-20"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.clearAllCounty();
                  this.props.clearAllDMA();
                  this.props.clearAllSelectedCity();
                  this.props.clearAllSelectedState();
                  this.props.clearAllZipCode();
                  this.props.clearAllAutoSelected();
                  this.props.clearAllRegionSelected();
                  this.props.clearAudienceCount();
                  this.props.setPlotValues({});
                  this.props.selectSegment([]);
                  this.props.setSegmentName("");
                  const segmentNameInput = ReactDOM.findDOMNode(
                    this.refs.segmentNameInput,
                  );
                  segmentNameInput.value = "";
                  this.props.setTargetHouseholdOnly(false);
                  this.setState({
                    openReset: false,
                    selectedCatId: undefined,
                    selectedAttrId: undefined,
                  });
                }}
              >
                Yes, Reset
              </a>
            </div>
          </div>
        </div>
      </MaterialPopover>
    );
  }

  getExitPopup() {
    return (
      <MaterialPopover
        open={this.state.openCancel}
        anchorEl={this.state.cancelAnchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        targetOrigin={{ horizontal: "left", vertical: "center" }}
        onRequestClose={this.handleRequestClose}
      >
        <div
          style={{
            padding: "20px 30px",
            fontSize: "16px",
          }}
        >
          Are you sure you want to exit?
          <br />
          Any selections you have made will not be saved
          <br />
          <br />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <a
                className="btn btn-link btn-sm cancel-btn mr-20 text-bold"
                onClick={(e) => {
                  this.handleOpenCancelDialog(e, false);
                }}
              >
                Close
              </a>
            </div>
            <div>
              <a
                className="btn btn-default btn-round btn-sm btn-aa-primary ml-20"
                onClick={(e) => {
                  e.preventDefault();
                  window.location =
                    "/segments/list/active" +
                    (this.props.selected_client
                      ? `?cid=${this.props.selected_client}`
                      : "");
                }}
              >
                Yes, exit
              </a>
            </div>
          </div>
        </div>
      </MaterialPopover>
    );
  }

  closeSelectedAttrDialog() {
    this.setState({
      openViewSelected: false,
    });
  }
  delayRecalculate() {
    setTimeout(
      function () {
        this.recalculateTotal();
      }.bind(this),
      200,
    );
  }
  getViewSelected() {
    return (
      <Dialog
        open={this.state.openViewSelected}
        onRequestClose={this.closeSelectedAttrDialog.bind(this)}
        modal={false}
        autoScrollBodyContent={true}
        contentStyle={{
          width: "1180px",
          maxWidth: "none",
        }}
        actionsContainerStyle={{
          padding: "20px 40px",
        }}
        actions={[
          <a
            className="btn btn-aa-info pt-10 pb-10 mr-20 pr-20"
            onClick={(e) => {
              e.preventDefault();
              this.closeSelectedAttrDialog();
            }}
          >
            Close
          </a>,
        ]}
      >
        <div
          className="text-default no-padding no-margin"
          style={{ marginTop: "-40px !important" }}
        >
          <SelectedAttrs
            selectedAttrs={this.props.selected_segments}
            plottedRadius={this.props.plotted_values}
            selected_state={this.props.selected_state}
            selected_city={this.props.selected_city}
            selected_county={this.props.selected_county}
            selected_dma={this.props.selected_dma}
            categories={this.props.demoAttributes}
            clearAllSelectedState={() => {
              this.props.clearAllSelectedState();
              this.delayRecalculate();
            }}
            clearAllSelectedCity={() => {
              this.props.clearAllSelectedCity();
              this.delayRecalculate();
            }}
            clearAllZipCode={() => {
              this.props.clearAllZipCode();
              this.delayRecalculate();
            }}
            clearZipCode={(val) => {
              this.props.clearZipCode(val);
              this.delayRecalculate();
            }}
            clearAllCounty={() => {
              this.props.clearAllCounty();
              this.delayRecalculate();
            }}
            clearAllDMA={() => {
              this.props.clearAllDMA();
              this.delayRecalculate();
            }}
            selectState={(obj, checked) => {
              this.props.selectState(obj, checked);
              this.delayRecalculate();
            }}
            selectCity={(obj, checked) => {
              this.props.selectCity(obj, checked);
              this.delayRecalculate();
            }}
            selectCounty={(obj, checked) => {
              this.props.selectCounty(obj, checked);
              this.delayRecalculate();
            }}
            selectDMA={(obj, checked) => {
              this.props.selectDMA(obj, checked);
              this.delayRecalculate();
            }}
            zipcode={this.props.zipcode}
            width={this.state.width}
            removeAttribute={this.removeSelectedVal.bind(this)}
            removePlottedVal={this.removePlottedVal.bind(this)}
            selected_make={this.props.selected_make}
            selected_model={this.props.selected_model}
            selected_client_name={this.props.selected_client_name}
          />
        </div>
        <div className="text-right mt-20"></div>
        {/*
        <div
          className="pull-right"
          style={{
            position: "absolute",
            top: "40px",
            left: this.state.width - 80 + "px",
          }}
        >
          <a onClick={this.closeSelectedAttrDialog}>
            <i className="icon-cancel-square text-teal-400" />
          </a>
        </div>*/}
      </Dialog>
    );
  }

  onSearchInputChange(text) {
    this.setState({
      search_input: text,
    });
  }

  handleSearchChange(e) {
    if (e) {
      const result = e[0];
      const { demoAttributes } = this.props;
      if (result["id"]) {
        map(demoAttributes, (cat) => {
          map(flattenDeep(cat.attributes), (attr) => {
            if (attr.id === result["id"]) {
              //this.setState({ selectKeyPair: attr, hightlightCid: cat.id });
              //ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";
              this.setState({
                selectedCatId: cat.id,
                selectedAttrId: attr.id,
              });
            }
            map(attr.values, (val) => {
              if (val.id === result["id"]) {
                /*
                this.setState({
                  highlightAid: val.id,
                  hightlightCid: cat.id,
                  selectKeyPair: attr,
                });
                ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";*/
                this.setState({
                  selectedCatId: cat.id,
                  selectedAttrId: attr.id,
                });
              }
            });
            map(attr.subAttributes, (subAttr) => {
              map(subAttr.values, (val) => {
                if (val.id === result["id"]) {
                  this.setState({
                    selectedCatId: cat.id,
                    selectedAttrId: attr.id,
                  });
                  /*
                  this.setState({
                    highlightAid: val.id,
                    hightlightCid: cat.id,
                    selectKeyPair: attr,
                  });
                  ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";*/
                }
              });
            });
          });
        });
      }
    }
    /*
    this.setState({
      highlightId: 0,
      highlightAid: 0,
      hightlightCid: 0,
      selectKeyPair: {},
    });
    if (e) {
      const result = e[0];
      if (result) {
        this.setState({ highlightId: result["id"] });
        const { demoAttributes } = this.props;

        map(demoAttributes, cat => {
          const group_id = "cat-attr-" + cat.id + "-item-group";

          map(flattenDeep(cat.attributes), attr => {
            if (attr.id === result["id"]) {
              this.setState({ selectKeyPair: attr, hightlightCid: cat.id });
              ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";
            }
            map(attr.values, val => {
              if (val.id === result["id"]) {
                this.setState({
                  highlightAid: val.id,
                  hightlightCid: cat.id,
                  selectKeyPair: attr,
                });
                ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";
              }
            });
            map(attr.subAttributes, subAttr => {
              map(subAttr.values, val => {
                if (val.id === result["id"]) {
                  this.setState({
                    highlightAid: val.id,
                    hightlightCid: cat.id,
                    selectKeyPair: attr,
                  });
                  ReactDOM.findDOMNode(this.refs[group_id]).style.height =
                    "auto";
                }
              });
            });
          });
        });
      }
    }*/
  }

  renderSearchMenu(results, menuProps) {
    let idx = 0;

    const equal_results = [];
    const other_results = [];
    map(results, (result) => {
      if (result.label.toUpperCase() === this.state.search_input.toUpperCase())
        equal_results.push(result);
      else other_results.push(result);
    });

    const match_grouped = groupBy(equal_results, (r) => r.parent);
    const match_items = Object.keys(match_grouped)
      .sort()
      .map((parent) => {
        return [
          !!idx && <MenuDivider key={`${parent}-divider`} />,
          <MenuHeader key={`${parent}-header`}>{parent}</MenuHeader>,
          map(match_grouped[parent], (obj) => {
            const item = (
              <MenuItem key={idx} option={obj} position={idx}>
                {obj.label}
              </MenuItem>
            );

            idx++;
            return item;
          }),
        ];
      });

    const grouped = groupBy(other_results, (r) => r.parent);
    const items = Object.keys(grouped)
      .sort()
      .map((parent) => {
        return [
          !!idx && <MenuDivider key={`${parent}-divider`} />,
          <MenuHeader key={`${parent}-header`}>{parent}</MenuHeader>,
          map(grouped[parent], (obj) => {
            const item = (
              <MenuItem key={idx} option={obj} position={idx}>
                {obj.label}
              </MenuItem>
            );

            idx++;
            return item;
          }),
        ];
      });

    return <Menu {...menuProps}>{[match_items, items]}</Menu>;
  }
  ifDisabledExportButton() {
    if (
        (this.props.selected_dma.length > 0 ||
        this.props.selected_city.length > 0 ||
        this.props.selected_state.length > 0 ||
        this.props.selected_county.length > 0 ||
        this.props.zipcode.length > 0) &&
        this.props.selected_segments.length > 0
    ) {
      return false;
    }
    return true;
  }
  componentWillReceiveProps(nextProps, nextContext) {
    this.computedSelectedGeo(nextProps);
    this.computedSelectedOtherSegment(nextProps);
  }

  computedSelectedOtherSegment = (nextProps) => {
    const other = [];
    nextProps.value_typehead.forEach(value => {
      nextProps.selected_segments.forEach(segment => {
        if (segment === value.id)  {
          const parent = nextProps.value_typehead.find(l => l.label === value.parent);
          other.push({
            id: parent.id,
            name: value.parent
          })
        }
      })
    });
    this.setState({
      otherSegmentDropDownList: other,
    })
  }

  computedSelectedGeo = (nextProps) => {
    const geoArrs = [];
    if (nextProps.selected_city.length > 0 || nextProps.selected_state.length > 0) {
      geoArrs.push({
        id: nextProps.selected_city.length > 0 ? 3 : 1,
        name: 'City/State'
      })
    }
    if (nextProps.selected_dma.length > 0) {
      geoArrs.push({
        id: 4,
        name: 'Dma'
      })
    }
    if (nextProps.zipcode.length > 0) {
      geoArrs.push({
        id: 7,
        name: 'Zip Code'
      })
    }
    if (nextProps.selected_county.length > 0) {
      geoArrs.push({
        id: 2,
        name: 'County'
      })
    }
    this.setState({
      geoDropDownList: geoArrs,
    });
  }
  requestDownloadCsvApi(data) {
    fetch('/api/segments/grouping-counts', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('aa_access_token')
      },
      body: JSON.stringify(data)
    }).then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch the CSV file');
      }
      const disposition = response.headers.get('Content-Disposition');
      let filename = 'download.csv'; // default filename

      if (disposition && disposition.includes('filename=')) {
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          filename = match[1].replace(/['"]/g, ''); // remove quotes
        }
      }

      return response.blob().then(blob => ({ blob, filename }));
    }).then(({ blob, filename }) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
  }
  handleExportCsv = () => {
    if (
        (
        this.state.exportCsvField.email ||
        this.state.exportCsvField.directMail ||
        this.state.exportCsvField.socialDisplay) &&
        (this.state.exportCsvField.geo && this.state.exportCsvField.other)
    ) {
      if (this.props.zipcode.length > 0) {
        parseZipcode(this.props, this.props.segment_name);
      }
      const newSegment = parseSegment(
          this.props,
          this.props.segment_name,
          this.state.plotted_values,
      );
      if (
          newSegment.rules.length > 0 ||
          this.props.selected_city.length > 0 ||
          this.props.selected_state.length > 0 ||
          this.props.zipcode.length > 0 ||
          this.props.selected_dma.length > 0 ||
          this.props.selected_county.length > 0
      ) {
        const { targetHouseholdsOnly } = this.props;
        /**
         * filter non-geo
         */
        const newRules = newSegment.rules.filter(l => [this.state.exportCsvField.geo.id, this.state.exportCsvField.other.id].includes(l.attributeId));
        const channels = [];
        if (this.state.exportCsvField.email) {
          channels.push('email');
        }
        if (this.state.exportCsvField.directMail) {
          channels.push('directMail');
        }
        if (this.state.exportCsvField.socialDisplay) {
          channels.push('social');
        }
        this.requestDownloadCsvApi({
          rules: newRules,
          filtered: {
            targetHouseholdsOnly: isUndefined(undefined)
                ? Boolean(targetHouseholdsOnly)
                : undefined,
          },
          channels,
        });
      } else {
        this.props.clearAudienceCount();
      }
    }
  }
  render() {
    const segmentNameOnChange = debounceEventHandler(
      this.handleSegmentNameChange.bind(this),
      500,
    );
    if (isEmpty(this.props.demoAttributes) || isEmpty(this.props.allstates)) {
      return (
        <div
          style={{
            border: "solid 1px black",
            color: "#5C5C5C",
            background: "#FFF",
          }}
        >
          <FullRow
            className="no-margin-bottom pt-20 pb-20"
            style={{ fontWeight: "300" }}
          >
            <div
              style={{
                height: "600px",
                width: "100%",
                position: "relative",
                padding: "100px",
                fontSize: "24px",
                textAlign: "center",
              }}
            >
              <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
              &nbsp;Data Loading...
            </div>
          </FullRow>
        </div>
      );
    }
    const categories = map(this.props.demoAttributes, (attr) => {
      return {
        name: attr.name,
        id: attr.id,
      };
    });
    if (!isEmpty(categories)) categories.unshift({ name: "Geography", id: 0 });
    return (
      <div className="audience-builder-main">
        {this.getExitPopup()}
        {this.getResetAllPopup()}
        {this.getViewSelected()}
        <div className="light-grey-border pl-20 pr-20 pb-20 mb-20">
          <h2>Create Audience Segment</h2>
          <div className="pb-20 light-grey-bottom-border">
            {getUrlParameterByName("step") === "confirm"
              ? "Review your inputs and selections you've made."
              : "Select a combination of attributes and value pairs to build your audience segment."}
          </div>
          {getUrlParameterByName("step") === "confirm" ? (
            <div>
              <div style={{ display: "flex" }}>
                <div style={{ width: "70%", padding: "10px 0px 10px 40px" }}>
                  <h4>Attributes({this.getSelectedAttrCount()})</h4>
                </div>
                <div style={{ width: "25%", padding: "10px" }}>
                </div>
              </div>

              <SelectedAttrs
                selected_state={this.props.selected_state}
                selected_city={this.props.selected_city}
                selected_county={this.props.selected_county}
                selected_dma={this.props.selected_dma}
                clearAllSelectedState={() => {
                  this.props.clearAllSelectedState();
                  this.delayRecalculate();
                }}
                clearAllSelectedCity={() => {
                  this.props.clearAllSelectedCity();
                  this.delayRecalculate();
                }}
                clearAllZipCode={() => {
                  this.props.clearAllZipCode();
                  this.delayRecalculate();
                }}
                clearZipCode={(val) => {
                  this.props.clearZipCode(val);
                  this.delayRecalculate();
                }}
                clearAllCounty={() => {
                  this.props.clearAllCounty();
                  this.delayRecalculate();
                }}
                clearAllDMA={() => {
                  this.props.clearAllDMA();
                  this.delayRecalculate();
                }}
                selectState={(obj, checked) => {
                  this.props.selectState(obj, checked);
                  this.delayRecalculate();
                }}
                selectCity={(obj, checked) => {
                  this.props.selectCity(obj, checked);
                  this.delayRecalculate();
                }}
                selectCounty={(obj, checked) => {
                  this.props.selectCounty(obj, checked);
                  this.delayRecalculate();
                }}
                selectDMA={(obj, checked) => {
                  this.props.selectDMA(obj, checked);
                  this.delayRecalculate();
                }}
                selectedAttrs={this.props.selected_segments}
                plottedRadius={this.props.plotted_values}
                categories={this.props.demoAttributes}
                width={"100%"}
                hideTitle={true}
                removeAttribute={this.removeSelectedVal.bind(this)}
                removePlottedVal={this.removePlottedVal.bind(this)}
                zipcode={this.props.zipcode}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
                className="pt-20 pb-20 light-grey-top-border"
              >
                <div style={{ width: "280px", marginRight: "-20px" }}>
                  {" "}
                  <Checkbox
                    label={"Target Primary Decision Maker"}
                    labelStyle={{ fontSize: "16px" }}
                    iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
                    defaultChecked={Boolean(this.props.targetHouseholdsOnly)}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div
                style={{ display: "flex" }}
                className="pt-20 pb-20 light-grey-bottom-border mb-20"
              >
                <div className="pt-5">
                  <strong>Search Attribute</strong>
                </div>
                <div className="ml-20">
                  <Typeahead
                    labelKey="label"
                    options={this.props.value_typehead}
                    placeholder="Select Attribute or Value Pair"
                    minLength={1}
                    renderMenu={this.renderSearchMenu.bind(this)}
                    onChange={this.handleSearchChange.bind(this)}
                    onInputChange={this.onSearchInputChange.bind(this)}
                    style={{ fontSize: "16px" }}
                    ref={(typeahead) => (this.typeahead = typeahead)}
                  />
                </div>
                <div
                  style={{
                    flexGrow: "1",
                    textAlign: "right",
                    paddingTop: "10px",
                  }}
                >
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ openViewSelected: true });
                    }}
                  >
                    View Attributes Selected
                  </a>
                </div>
              </div>
              {categories && (
                <div style={{ display: "flex" }}>
                  <div>
                    <TreePanel
                      displayData={categories}
                      title={"Category"}
                      selectedId={this.state.selectedCatId}
                      onClick={(id) => {
                        this.setState({
                          selectedCatId: id,
                          selectedAttrId: null,
                        }); /*
                        this.props.clearAudienceCount();
                        this.props.clearAllSelectedState();
                        this.props.clearAllSelectedCity();
                        this.props.clearAllZipCode();
                        this.props.clearAllDMA();
                        this.props.clearAllCounty();*/
                      }}
                    />
                  </div>
                  {this.getAttributesPanel()}
                  {this.getValuesPanel()}
                  {this.getAttrValuesPanel()}
                </div>
              )}
              <div style={{ width: "100%" }} className="pt-20 pb-20 text-right">
                <a
                  href="#"
                  className={
                    this.getSelectedAttrCount() > 0
                      ? "btn btn-default btn-aa-default"
                      : "btn btn-default btn-aa-default disabled"
                  }
                  onClick={(e) => {
                    this.handleOpenResetDialog(e, true);
                  }}
                >
                  Reset Attributes
                </a>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
                className="pt-20 pb-20 light-grey-top-border"
              >
              </div>
            </div>
          )}
          <div
            style={{
              width: "100%",
              paddingTop: "18px",
              background: "#F5F5F5",
              height: "60px",
              textAlign: "center",
            }}
          >
            <strong>Channel Reach</strong>
          </div>
          <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
              className="pt-20 pb-20"
          >
            <div>
              <img src="/images/media_web.png"/> <strong>Email:</strong>{" "}
              {this.props.audience_total_count
                  ? splitNumber(this.props.audience_total_count.email)()
                  : ""}
            </div>
            <div>
              <img src="/images/media_social.png"/> <strong>Social/Display:</strong>{" "}
              {this.props.audience_total_count
                  ? splitNumber(this.props.audience_total_count.social)()
                  : ""}
            </div>
            <div>
              <img src="/images/media_email.png"/> <strong>Direct Mail:</strong>{" "}
              {this.props.audience_total_count
                  ? splitNumber(this.props.audience_total_count.directMail)()
                  : ""}
            </div>
          </div>
          <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
              className="pt-20 light-grey-top-border"
          >
            <div style={{display: "flex" }}>
              <strong style={{ paddingTop: "10px" }}>Name the Audience </strong>
              {getUrlParameterByName("step") === "confirm" ? (
                <div className="ml-20 pt-10">{this.props.segment_name}</div>
              ) : (
                <input
                  type="text"
                  ref="segmentNameInput"
                  className="ml-10 pt-5 pb-5 pl-10 pr-10"
                  style={{
                    border: "solid 1px #B3B3B3",
                    width: "400px",
                    fontSize: "16px",
                  }}
                  maxLength={60}
                  onChange={segmentNameOnChange.bind(this)}
                  defaultValue={this.props.segment_name}
                />
              )}
            </div>
            <div>
              <a
                  onClick={() => {
                    this.setState({
                      openExportCsvModal: true,
                    })
                  }}
                  className={this.ifDisabledExportButton() ? "btn btn-default btn-aa-default mr-20 disabled": "btn btn-default btn-aa-default mr-20"}
              >Export</a>
              {getUrlParameterByName("step") === "confirm" && (
                <a
                  className="btn btn-default btn-aa-default mr-20"
                  onClick={(e) => {
                    e.preventDefault();
                    window.history.back();
                  }}
                >
                  Back
                </a>
              )}
              <a
                className="btn btn-aa-info mr-10 pt-10 pb-10 ml-10"
                href="#"
                onClick={(e) => {
                  this.handleOpenCancelDialog(e, true);
                }}
              >
                Cancel
              </a>
              <a
                className={
                  isEmpty(this.props.segment_name) ||
                  this.getSelectedAttrCount() <= 0
                    ? "btn btn-default btn-aa-default disabled"
                    : "btn btn-default btn-aa-default"
                }
                onClick={(e) => {
                  e.preventDefault();
                  if (getUrlParameterByName("step") === "confirm")
                    this.saveSegment();
                  else this.verifyAudience();
                }}
                href="#"
              >
                {getUrlParameterByName("step") === "confirm" ? "Save" : "Next"}
              </a>
            </div>
          </div>
          {this.state.errorVisible && (
            <div
              style={{
                color: "#ff0000",
              }}
            >
              This segment name already exists, please enter a unique segment
              name to continue{" "}
            </div>
          )}
        </div>
        <Dialog
            open={this.state.openExportCsvModal}
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Export Counts</span>
                <IconButton onClick={() => {
                  this.setState({
                    openExportCsvModal: false,
                  })
                }}>
                  <CloseIcon />
                </IconButton>
              </div>
            }
            actions={[
                  <a
                      className="btn btn-aa-info pt-10 pb-10 mr-20 pr-20"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({
                          openExportCsvModal: false,
                        })
                      }}
                  >
                    Close
                  </a>,
                  <a
                      onClick={this.handleExportCsv}
                  className={(this.state.exportCsvField.email || this.state.exportCsvField.socialDisplay || this.state.exportCsvField.directMail) && (this.state.exportCsvField.geo.id && this.state.exportCsvField.other.id) ? "btn btn-default btn-aa-default mr-20": "btn btn-default btn-aa-default mr-20 disabled"}
                  >Export</a>
                ]}
        >
          <div>
            <div style={{display: 'flex'}}>
              <div style={{width: '694px'}}>Channel</div>
              <Checkbox label="Email" checked={this.state.exportCsvField.email} onCheck={(value, isChecked) => {
                this.setState({
                  exportCsvField: {
                    ...this.state.exportCsvField,
                    email: isChecked,
                  }
                })
              }}/>
              <Checkbox label="Social/Display" checked={this.state.exportCsvField.socialDisplay} onCheck={(value, isChecked) => {
                this.setState({
                  exportCsvField: {
                    ...this.state.exportCsvField,
                    socialDisplay: isChecked,
                  }
                })
              }}/>
              <Checkbox label="Direct Mail" checked={this.state.exportCsvField.directMail} onCheck={(value, isChecked) => {
                this.setState({
                  exportCsvField: {
                    ...this.state.exportCsvField,
                    directMail: isChecked,
                  }
                })
              }}/>
            </div>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <div style={{marginTop: '28px', marginRight: '79px'}}>Geography</div>
              <SelectField
                  fullWidth={true}
                  maxHeight={120}
                  floatingLabelText="Select an option"
                  value={this.state.exportCsvField.geo.id}
                  onChange={(e, index, value) => {
                    this.setState({
                      exportCsvField: {
                        ...this.state.exportCsvField,
                        geo: {
                          id: this.state.geoDropDownList[index].id,
                          name: this.state.geoDropDownList[index].name
                        }
                      }
                    })
                  }}
              >
                {
                  this.state.geoDropDownList.map(item => (
                      <MItem value={item.id} primaryText={item.name} key={item.id}/>
                  ))
                }
              </SelectField>
            </div>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <div style={{marginTop: '28px', marginRight: '10px', width: '207px'}}>Other Categories</div>
              <SelectField
                  fullWidth={true}
                  maxHeight={120}
                  floatingLabelText="Select an option"
                  value={this.state.exportCsvField.other.id}
                  onChange={(e, index, value) => {
                    this.setState({
                      exportCsvField: {
                        ...this.state.exportCsvField,
                        other: {
                          id: this.state.otherSegmentDropDownList[index].id,
                          name: this.state.otherSegmentDropDownList[index].name
                        }
                      }
                    })
                  }}
              >
                {
                  this.state.otherSegmentDropDownList.map(item => (
                      <MItem value={item.id} primaryText={item.name} key={item.id}/>
                  ))
                }
              </SelectField>
            </div>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <div style={{marginTop: '28px', marginRight: '10px', width: '203px'}}>Summary</div>
              <div style={{width: '100%'}}>
                <section>These selections will be applied to the export file</section>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                  {
                    this.state.exportCsvField.email && (
                        <Chip style={{margin: '2px 4px'}}>
                          { `Chanel:email` }
                        </Chip>
                      )
                  }
                  {
                      this.state.exportCsvField.socialDisplay && (
                          <Chip style={{margin: '2px 4px'}}>
                            { `Chanel:Social/Display` }
                          </Chip>
                      )
                  }
                  {
                      this.state.exportCsvField.directMail && (
                          <Chip style={{margin: '2px 4px'}}>
                            { `Chanel:Direct Mail` }
                          </Chip>
                      )
                  }
                  {
                      this.state.exportCsvField.geo && (
                          <Chip style={{margin: '2px 4px'}}>
                            { `Geography:${this.state.exportCsvField.geo.name}` }
                          </Chip>
                      )
                  }
                  {
                      this.state.exportCsvField.other && (
                          <Chip style={{margin: '2px 4px'}}>
                            { `Other:${this.state.exportCsvField.other.name}` }
                          </Chip>
                      )
                  }
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default AudienceBuilder;



// WEBPACK FOOTER //
// ./src/components/AudienceBuilder/index.js